module.exports = __webpack_public_path__ + "h5assets/img/pic_7.2a70cf4.png";